import styled from 'styled-components';

import {Link} from 'react-router-dom';

interface ButtonProps {
  width?: 'expand' | 'fit-content';
  size?: 'small' | 'default';
  danger?: boolean;
}

export const Container = styled(Link)<ButtonProps>`
  width: ${(props) => (props.width === 'fit-content' ? 'fit-content' : '100%')};
  padding: 10px 15px;
  font-size: ${(props) => (props.size === 'small' ? 12 : 14)}px;
  background-color: ${(props) =>
    props.danger ? props.theme.colors.red : props.theme.colors.primary};
  transition: all 0.2s ease-in-out;
  border: none;
  cursor: pointer;
  color: white;
  border-radius: 3px;
  font-weight: bold;
  position: relative;
  overflow: hidden;

  &:hover {
    background-color: ${(props) =>
      props.danger
        ? props.theme.colors.redHover
        : props.theme.colors.primaryHover};
  }
`;
